var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "over_layout" }, [
    _c("section", { staticClass: "error_page" }, [
      _c("div", { staticClass: "wrapper" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$store.getters.t("sorry_404")))]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "button_style" },
          [
            _c(
              "router-link",
              {
                attrs: {
                  to: {
                    name: "home",
                    params: { lang: _vm.$store.getters.locale }
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$store.getters.t("backtohomepage")))]
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top_icon_error" }, [
      _c("img", { attrs: { src: "/vue/images/error_icon_top.png" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text_error_404" }, [
      _c("strong", [_vm._v("4")]),
      _vm._v(" "),
      _c("div", { staticClass: "icon_0" }, [
        _c("img", { attrs: { src: "/vue/images/error_lightbulb_OFF.png" } })
      ]),
      _vm._v(" "),
      _c("strong", [_vm._v("4")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c01741c2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c01741c2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/errors/404.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c01741c2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/errors/404.vue
// module chunks = 0